import { RequestReadState } from '@atlassian/notification-common/types';
var READ_STATE_FILTER_KEY = 'notification-list.readStateFilter';
export var GROUPED_NOTIFICATIONS_VIEW_FILTER_KEY = 'notification-list.groupedNotficationsView';
var saveToLocalStorage = function saveToLocalStorage(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {}
};
var loadFromLocalStorage = function loadFromLocalStorage(key) {
  try {
    var _localStorage$getItem;
    return (_localStorage$getItem = localStorage.getItem(key)) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : '';
  } catch (e) {
    return '';
  }
};
export var saveReadStateFilterToLocalStorage = function saveReadStateFilterToLocalStorage(readState) {
  saveToLocalStorage(READ_STATE_FILTER_KEY, readState);
};
export var saveGroupedNotificationsViewToLocalStorage = function saveGroupedNotificationsViewToLocalStorage(groupedNotificationsView) {
  saveToLocalStorage(GROUPED_NOTIFICATIONS_VIEW_FILTER_KEY, String(groupedNotificationsView));
};
export var loadReadStateFilterFromLocalStorage = function loadReadStateFilterFromLocalStorage() {
  var loadedReadState = loadFromLocalStorage(READ_STATE_FILTER_KEY);
  return Object.values(RequestReadState).includes(loadedReadState) ? loadedReadState : RequestReadState.ANY;
};
export var loadGroupedNotificationsViewFromLocalStorage = function loadGroupedNotificationsViewFromLocalStorage() {
  try {
    var loadedGroupedNotificationsView = loadFromLocalStorage(GROUPED_NOTIFICATIONS_VIEW_FILTER_KEY);
    // The value should default to true when not present.
    // loadFromLocalStorage returns '' if the key doesn't exist
    return loadedGroupedNotificationsView === 'true' || loadedGroupedNotificationsView === '';
  } catch (e) {
    return true;
  }
};